import { CardsCarousel as HygraphCardsCarousel } from '@/lib/types';

import { CardsCarouselProps } from '@/components/cards-carousel';

import { CarouselPerPage } from '@/features/carousel';
import cardTransformer from '@/hygraph/transformers/card.transformer';

export default function cardsCarouselTransformer(
  props: HygraphCardsCarousel
): CardsCarouselProps {
  return {
    cards: props.cards.map(cardTransformer),
    desktopCardsPerPage: numberToCarouselPerPage(props.desktopCardsNumber),
    mobileCardsPerPage: numberToCarouselPerPage(props.mobileCardsNumber),
  };
}

const mapNumberToCarouselPerPage: Record<number, CarouselPerPage> = {
  1: CarouselPerPage.ONE,
  2: CarouselPerPage.TWO,
  3: CarouselPerPage.THREE,
  4: CarouselPerPage.FOUR,
};

function numberToCarouselPerPage(n: number): CarouselPerPage {
  return mapNumberToCarouselPerPage[n] || CarouselPerPage.ONE;
}
